import { isWeb } from "../utilities/platform";

export const isBuild = process.env.NODE_ENV === "production";
export const isProduction = isBuild && process.env.GATSBY_BUILD_PROD === "true";
export const isDemo = isBuild && process.env.GATSBY_BUILD_STAGING === "true";
export const isBuildingOnDevice = isBuild && !isDemo && !isProduction;  // WHEN STEVE BUILDS ON HIS OWN COMPUTER

const BackendUrl = {
  DEMO: 'https://demo-public-api.healthnex.com.au',
  PRODUCTION: 'https://publicapi.healthnex.com.au',
  LOCAL_254: 'http://192.168.15.254:5194',
  LOCAL_253: 'http://192.168.15.253:5001',
  LOCAL_252: 'http://192.168.15.252:5001',
  LOCAL_249: 'http://192.168.15.248:5194',
  LOCAL_250: 'http://192.168.15.250:5194',
  LOCAL_248: 'http://192.168.0.151:5194',
  // JUNE: 'http://172.20.10.6:5194'
  JUNE: 'http://192.168.1.151:5194',
  TEMP: 'http://192.168.0.151:5194',
};

// Build Name: dev-vai-public-home-platform-2025-10-30
// Production FE: https://healthnex.com.au
// Demo FE: https://vai-platform.cmasa.org.au

const LocalBuildKey: 'DEMO' | 'PRODUCTION' = 'DEMO'; // 'DEMO' or 'PRODUCTION' use with isBuildingOnDevice only

// const IsBuilding4Production = false;
// const IsBuilding4Dev = !IsBuilding4Production;
// const devBackEndUrl = BackendUrl.LOCAL_248;

export const backEndBaseURL = isDemo ? BackendUrl.DEMO :
  isProduction ? BackendUrl.PRODUCTION :
    isBuildingOnDevice ? BackendUrl[LocalBuildKey] :             // FOR WHEN STEVE IS BUILDING LOCALLY
      BackendUrl.LOCAL_248;                                      // FOR DEVELOPMENT

const SQUARE_PAYMENT_IDS = {
  PRODUCTION: "sq0idp-gxIjm6fNU1jd5oAiojnUYw",
  DEMO: "sandbox-sq0idb-7wkiUlmjTmYIXmjkpTv9ww",
};

export const SQUARE_APPLICATION_ID = isProduction ? SQUARE_PAYMENT_IDS.PRODUCTION :
  isDemo ? SQUARE_PAYMENT_IDS.DEMO :
    isBuildingOnDevice ? SQUARE_PAYMENT_IDS[LocalBuildKey] :    // FOR WHEN STEVE IS BUILDING LOCALLY
      SQUARE_PAYMENT_IDS.DEMO;                                  // FOR DEVELOPMENT                


// PRACTITIONER FE URL
const PRACTITIONER_PORTAL_URLS = {
  PRODUCTION: "https://practitioner.healthnex.com.au",
  DEMO: "https://vai-clinic-practitioner.cmasa.org.au",
};

export const PractitionerPortalUrl = isProduction ? PRACTITIONER_PORTAL_URLS.PRODUCTION :
  isDemo ? PRACTITIONER_PORTAL_URLS.DEMO :
    isBuildingOnDevice ? PRACTITIONER_PORTAL_URLS[LocalBuildKey] :      // FOR WHEN STEVE IS BUILDING LOCALLY
      PRACTITIONER_PORTAL_URLS.DEMO;                                    // FOR DEVELOPMENT


// PRACTITIONER BACKEND
const PRACTITIONER_BACKEND_URLS = {
  PRODUCTION: "https://practitionerapi.healthnex.com.au",
  DEMO: "https://vai-practitioner-api.cmasa.org.au",
};

export const practitionerBackEndUrl = isProduction ? PRACTITIONER_BACKEND_URLS.PRODUCTION :
  isDemo ? PRACTITIONER_BACKEND_URLS.DEMO :
    isBuildingOnDevice ? PRACTITIONER_BACKEND_URLS[LocalBuildKey] :     // FOR WHEN STEVE IS BUILDING LOCALLY
      PRACTITIONER_BACKEND_URLS.DEMO;                                   // FOR DEVELOPMENT                  


// COMMUNITY FE URL
const COMMUNITY_FE_URL = {
  PRODUCTION: "https://community.healthnex.com.au",
  DEMO: "https://vai-community.cmasa.org.au",
};

export const communityBackEndUrl = isProduction ? COMMUNITY_FE_URL.PRODUCTION :
  isDemo ? COMMUNITY_FE_URL.DEMO :
    isBuildingOnDevice ? COMMUNITY_FE_URL[LocalBuildKey] : // FOR WHEN STEVE IS BUILDING LOCALLY
      COMMUNITY_FE_URL.DEMO;                               // FOR DEVELOPMENT

export const THIRD_PARTY_URL = {
  BOOK_DEMO: "https://scheduler.zoom.us/william-li-healthnex/healthnex-onboard-training",
};

export const encryptedPassword = "*ENCRYPTEDPASSWORD*";

// LANGUAGE
// Chinese (zh-CN) support, i18next and the language switcher UI are kept in the codebase and can be
// re-enabled at any time by flipping ENABLE_LANGUAGE_SWITCHER back to true. That flag only controls
// the marketing navbar switcher in shared-layout; the functional routes below manage their own.
export const ENABLE_LANGUAGE_SWITCHER = false;
export const DEFAULT_LANGUAGE = "en-AU";
export const SUPPORTED_LANGUAGES = ["en-AU", "zh-CN"];

// Routes allowed to run in a language other than DEFAULT_LANGUAGE. Everything else is pinned to
// DEFAULT_LANGUAGE, so a language a patient picked on Clinic Check In cannot follow them onto the
// marketing site. Matched by prefix, so nested paths inherit the policy.
// Patient Consent is here because it is reached by a ?lang= deep link and then strips that param
// from the URL - without it, the page would flip back to English right after cleaning the URL.
export const LANGUAGE_ENABLED_ROUTES = [
  "/clinic-check-in",
  "/quick-sign-up",
  "/patient-consent",
];

export const IsLanguageEnabledRoute = (pathname: string = "") =>
  LANGUAGE_ENABLED_ROUTES.some((route) => pathname.startsWith(route));


export const version = "0.1.3.5";

export const CURRENT_PLATFORM = 1;
